<template>
  <div class="pass-card-item" 
       data-sensors-exposure-property-caseId="pass"
       data-sensors-exposure-event-name="Element_Exposure"
       @click="withdrawAction"
  >
    <img src="../../images/icon_home_swipeItem_channelExclusive.png">
    <div class="title">免审可借(元)</div>
    <div class="amount">{{passLimitAmount | currency}}</div>
    <div class="amount-count-down" v-if="countdownVisible && countDownDuration>0 && !isFinish">
      <span>距离额度{{ passIndexCardInfo.limitExpireShowType === 'LIMIT_LOCK' ? '更新' : '失效' }}还有&nbsp;</span>
      <van-count-down
        :time="countDownDuration"
        :format="dateFormat"
        @finish="isFinish=true"
      />
    </div>
    <div class="tips">100%平台通过率，被拒全额退</div>
    <nd-button class="btn auth-passcard-btn" :disabled="withdrawButtonDisable"  data-sensors-click >立即提现</nd-button>
  </div>
</template>

<script>
import { SwipeItem } from 'vant'
export default {
  data () {
    return {
      isFinish: false
    }
  },
  components: {
    SwipeItem
  },
  props: {
    passIndexCardInfo: {
      type: Object,
      default: null
    }
  },
  computed: {
    countdownVisible () {
      return !this.isEmptyString(this.passIndexCardInfo.limitExpireShowType) && this.passIndexCardInfo.limitExpireShowType !== 'LIMIT_FROZEN'
    },
    withdrawButtonDisable () {
      return ['LIMIT_LOCK', 'LIMIT_FROZEN'].includes(this.passIndexCardInfo.limitExpireShowType)
    },
    passLimitAmount () {
      return parseInt(this.passIndexCardInfo.passLimitAmount)
    },
    countDownDuration () {
      return this.passIndexCardInfo.expireCountDownTime * 1000
    },
    dateFormat () {
      if (this.countDownDuration > 86400000) {
        return 'DD天HH:mm:ss'
      } else if (this.countDownDuration > 3600000) {
        return 'HH:mm:ss'
      } else {
        return 'mm:ss'
      }
    }
  },
  methods: {
    withdrawAction () {
      if (!this.withdrawButtonDisable) {
        this.$emit('withdrawAction')
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.pass-card-item {
  width: 670px;
  padding: 56px 30px 30px 30px;
  background: #ffffff;
  box-shadow: 0px  15px 30px 0px rgba(211, 211, 211, 0.8);
  margin: 0 auto;
  overflow: hidden;
  position: relative;
  text-align: center;
  border-radius: 20px;
  margin: 0 auto;
  img {
    width: 180px;
    height: 54px;
    position: absolute;
    top: 0;
    left: 0;
  }
  .title {
    font-size: 28px;
    font-weight: 400;
    color: #333333;
    line-height: 40px;
  }
  .amount {
    font-size: 80px;
    font-family: DIN-Medium, DIN;
    font-weight: 500;
    color: #333333;
    line-height: 97px;
  }
  .amount-count-down {
    font-size: 24px;
    font-weight: 400;
    color: #FF4633;
    line-height: 33px;
    margin-top: 18px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    .van-count-down {
      font-size: 24px;
      font-weight: 400;
      color: #FF4633;
      line-height: 33px;
    }
  }
  .tips {
    font-size: 24px;
    font-weight: 400;
    color: #999999;
    line-height: 33px;
    margin-top: 4px;
  }
  .btn {
    width: 460px;
    height: 88px;
    margin: 0 auto;
    margin-top: 24px;
  }
}
</style>